<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';

    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import TemplateHeaderDuo from '../../shared/TemplateHeaderDuo.svelte';
    import Tabs from '../../shared/Tabs.svelte';
    import FeaturesList from '../../shared/Features/FeaturesList.svelte';
    import AccountsTab from './AccountsTab.svelte';
    import UsageStats from './UsageStats.svelte';
    import StatsRecipientsTab from './StatsRecipientsTab.svelte';
    import { mainMenu } from '../../../stores/store';
    import { app } from '../../../stores/app';

    let selectedTab: string = 'features';

    $: tabs = [
        { id: 'features', label: $_('Features') },
        { id: 'accounts', label: $_('Accounts') },
        { id: 'usage-stats', label: $_('Usage stats') },
        { id: 'stats-recipients', label: $_('Stats recipients') },
    ];

    onMount(() => {
        $mainMenu.currentPage = 'PageAdmin';
    });
</script>

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderDuo>
            <div slot="main-header">
                {$_('Administration')}
            </div>
            <div slot="main-buttons" style="display: flex; justify-items: flex-end;">
                <!-- belka zakladek tylko dla admina: bez tego warunku konto bez uprawnien widzi
                     nazwy zakladek panelu, a klikniecie w nie zmienia stan strony pod komunikatem -->
                {#if $app.isAdmin}
                    <Tabs
                        selectedId={selectedTab}
                        items={tabs}
                        onChange={id => {
                            selectedTab = id;
                        }}
                    />
                {/if}
            </div>
        </TemplateHeaderDuo>
    </div>
    <div slot="content-header"></div>
    <div slot="content" style="overflow-y: auto; flex: 1; display: flex; flex-direction: column;">
        {#if !$app.isAdmin}
            <h3>{$_('admin_permission_required')}</h3>
        {:else}
            {#if selectedTab === 'features'}
                <div class="tab-content">
                    <FeaturesList />
                </div>
            {/if}
            {#if selectedTab === 'accounts'}
                <div class="tab-content">
                    <AccountsTab />
                </div>
            {/if}
            {#if selectedTab === 'usage-stats'}
                <div class="tab-content">
                    <UsageStats />
                </div>
            {/if}
            {#if selectedTab === 'stats-recipients'}
                <div class="tab-content">
                    <StatsRecipientsTab />
                </div>
            {/if}
        {/if}
    </div>
</TemplateStandard>

<style>
    .tab-content {
        margin: 20px 0;
        overflow-y: auto;
        flex: 1;
        display: flex;
        flex-direction: column;
    }
</style>
